// extracted by mini-css-extract-plugin
export default {"resourceTable":"style_resourceTable__8j3ze"};